import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const DELETE_ACTION_TENDENCY_MUTATION = gql`
    mutation DeleteActionTendency($uid: String!) {
      action_tendency_delete(uid: $uid) {
            success
        }
    }
`;

export async function deleteActionTendency(uid: string): Promise<{ success: boolean }> {
  const result: FetchResult<{ action_tendency_delete: { success: boolean } }> = await graphqlClient.mutate({
      mutation: DELETE_ACTION_TENDENCY_MUTATION,
      variables: { uid },
      errorPolicy: 'all',
  });

  if (!result.data || (result.errors && result.errors.length)) {
      throw new MultiError(result.errors || ['Unknown error']);
  }

  return {
    success: result.data.action_tendency_delete.success,
  };
}
